import { useEffect } from "react";
import { getWithExpiry, setWithExpiry } from "@helpers/storage";

const useHandleCache = () => {
  const clearCacheAndReload = async () => {
    try {
      if (window?.caches) {
        const { caches } = window;
        const cacheNames = await caches.keys();
        const cacheDeletionPromises = cacheNames.map((n) => caches.delete(n));
        await Promise.all(cacheDeletionPromises);
        window.location.reload();
      }
    } catch (error) {
      console.warn("An error occurred while deleting the cache.", error);
    }
    window.location.reload();
  };

  const checkVersionMismatch = (latestVersion, currentVersion) => {
    const latestVersionArr = latestVersion.split(/\./g);
    const currentVersionArr = currentVersion.split(/\./g);

    while (latestVersionArr.length || currentVersionArr.length) {
      const a = Number(latestVersionArr.shift());
      const b = Number(currentVersionArr.shift());

      if (a === b) continue;

      return a > b || isNaN(b);
    }

    return false;
  };

  useEffect(() => {
    const getLatestVersion = async () => {
      try {
        // get the latest version from the server
        const response = await fetch(
          `${import.meta.env.VITE_APP_BASE_URL}/v1/app/version`,
        );
        const parsedResponse = await response.json();
        const latestVersion = parsedResponse.data.version;
        const currentVersion = getWithExpiry("vrsn");

        const shouldForceRefresh =
          currentVersion && checkVersionMismatch(latestVersion, currentVersion);

        setWithExpiry("vrsn", latestVersion, 86400 * 1000);

        if (!shouldForceRefresh) return;
        void clearCacheAndReload();
      } catch (e) {
        console.warn("Oops, no version found in meta.json");
      }
    };

    void getLatestVersion();
  }, []);
};

export default useHandleCache;
